import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import PatternContent from './PatternContent';
import SymbolContent from './SymbolContent';

import { Else, If, Then } from 'react-if';

const emptyArray = []
const Content = ({ ...props }) => {
  const selectedSymbols = useSelector(state => state.seriesState.creatorState.selectedSymbols) || emptyArray,
        arePatternsSelected = useMemo(() => selectedSymbols.some(s => s.pattern === "true" || s.pattern === undefined), [selectedSymbols])
        
  return (
  <If condition={arePatternsSelected}>
    <Then>
      {() => (
        <PatternContent {...props}/>
      )}
    </Then>
    <Else>
      {() => (
        <SymbolContent {...props}/>
      )}
    </Else>

  </If>
  )
}

export default Content;